import { make } from 'vuex-pathify'
import Vue from 'vue'
import store from '../index'

const state = {
  loading: [false, false],
}

const mutations = make.mutations(state)

const createJob = async ({ state }, { reportCode, filter = {} }) => {
  const type = filter.type || 0
  Vue.set(state.loading, type, true)

  try {
    return await store.dispatch('reportJobStore/createJob', {
      module: 'basic',
      reportCode,
      format: type === 0 ? 'pdf' : 'csv',
      filters: filter,
    })
  } finally {
    Vue.set(state.loading, type, false)
  }
}

const actions = {
  getCustomers: (ctx, filter = {}) => createJob(ctx, { reportCode: 'customers', filter }),
  getUsers: (ctx, filter = {}) => createJob(ctx, { reportCode: 'users', filter }),
  getProducts: (ctx, filter = {}) => createJob(ctx, { reportCode: 'products', filter }),
  getInventories: (ctx, filter = {}) => createJob(ctx, { reportCode: 'inventory', filter }),
  getContracts: (ctx, filter = {}) => createJob(ctx, { reportCode: 'contracts', filter }),
  getServices: (ctx, filter = {}) => createJob(ctx, { reportCode: 'services', filter }),
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
